/* tslint:disable */
/* eslint-disable */
/**
 * RateRelief API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PolicyNameNumber } from './PolicyNameNumber';
import {
    PolicyNameNumberFromJSON,
    PolicyNameNumberFromJSONTyped,
    PolicyNameNumberToJSON,
    PolicyNameNumberToJSONTyped,
} from './PolicyNameNumber';

/**
 * 
 * @export
 * @interface UploadControllerGetChangesToValidateResponse
 */
export interface UploadControllerGetChangesToValidateResponse {
    /**
     * 
     * @type {string}
     * @memberof UploadControllerGetChangesToValidateResponse
     */
    emailRetentionUploadId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UploadControllerGetChangesToValidateResponse
     */
    bafoUploadId?: string | null;
    /**
     * 
     * @type {Array<PolicyNameNumber>}
     * @memberof UploadControllerGetChangesToValidateResponse
     */
    policiesToAdd?: Array<PolicyNameNumber> | null;
    /**
     * 
     * @type {Array<PolicyNameNumber>}
     * @memberof UploadControllerGetChangesToValidateResponse
     */
    policiesToAmmend?: Array<PolicyNameNumber> | null;
}

/**
 * Check if a given object implements the UploadControllerGetChangesToValidateResponse interface.
 */
export function instanceOfUploadControllerGetChangesToValidateResponse(value: object): value is UploadControllerGetChangesToValidateResponse {
    return true;
}

export function UploadControllerGetChangesToValidateResponseFromJSON(json: any): UploadControllerGetChangesToValidateResponse {
    return UploadControllerGetChangesToValidateResponseFromJSONTyped(json, false);
}

export function UploadControllerGetChangesToValidateResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UploadControllerGetChangesToValidateResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'emailRetentionUploadId': json['emailRetentionUploadId'] == null ? undefined : json['emailRetentionUploadId'],
        'bafoUploadId': json['bafoUploadId'] == null ? undefined : json['bafoUploadId'],
        'policiesToAdd': json['policiesToAdd'] == null ? undefined : ((json['policiesToAdd'] as Array<any>).map(PolicyNameNumberFromJSON)),
        'policiesToAmmend': json['policiesToAmmend'] == null ? undefined : ((json['policiesToAmmend'] as Array<any>).map(PolicyNameNumberFromJSON)),
    };
}

export function UploadControllerGetChangesToValidateResponseToJSON(json: any): UploadControllerGetChangesToValidateResponse {
    return UploadControllerGetChangesToValidateResponseToJSONTyped(json, false);
}

export function UploadControllerGetChangesToValidateResponseToJSONTyped(value?: UploadControllerGetChangesToValidateResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'emailRetentionUploadId': value['emailRetentionUploadId'],
        'bafoUploadId': value['bafoUploadId'],
        'policiesToAdd': value['policiesToAdd'] == null ? undefined : ((value['policiesToAdd'] as Array<any>).map(PolicyNameNumberToJSON)),
        'policiesToAmmend': value['policiesToAmmend'] == null ? undefined : ((value['policiesToAmmend'] as Array<any>).map(PolicyNameNumberToJSON)),
    };
}

